/* DSL Wishlist server-sync — als customer is logged in: sync localStorage <-> customer.metafields.dsl.wishlist via app-proxy endpoint */
(function(){
  var ENDPOINT = (window.DSL_CONFIG && window.DSL_CONFIG.wishlistEndpoint) || "/apps/dsl/wishlist";
  if (!window.DSL_WISHLIST) return;
  var customer = window.DSL_CUSTOMER || null;
  if (!customer || !customer.id) return; // anonymous: localStorage-only
  // Pull on load, merge with local
  fetch(ENDPOINT + "?customer_id=" + customer.id, {credentials:"same-origin"}).then(function(r){return r.json();}).then(function(data){
    if (!data || !data.handles) return;
    var local = window.DSL_WISHLIST.get();
    data.handles.forEach(function(h){ if (!local.has(h)) window.DSL_WISHLIST.toggle(h); });
    window.DSL_WISHLIST.applyState();
  }).catch(function(){});
  // Push on change
  document.addEventListener("dsl:wishlist:change", function(e){
    fetch(ENDPOINT, {
      method:"POST", credentials:"same-origin", headers:{"Content-Type":"application/json"},
      body: JSON.stringify({customer_id: customer.id, handles: [...window.DSL_WISHLIST.get()]})
    }).catch(function(){});
  });
})();